import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatSparkle = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "m14.81802,5.06557c2.13035,-0.42827 3.84544,-2.16425 4.27439,-4.34964c0.42895,2.18538 2.14364,3.92137 4.27397,4.34964m0,0.00247c-2.13035,0.42825 -3.84544,2.16425 -4.27439,4.34964c-0.42895,-2.18538 -2.14364,-3.92137 -4.27397,-4.34964",
		fill: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		d: "m14.81802,5.06557c2.13035,-0.42827 3.84544,-2.16425 4.27439,-4.34964c0.42895,2.18538 2.14364,3.92137 4.27397,4.34964m0,0.00247c-2.13035,0.42825 -3.84544,2.16425 -4.27439,4.34964c-0.42895,-2.18538 -2.14364,-3.92137 -4.27397,-4.34964m-4.03271,-1.39277l-7.96851,0c-1.15902,0 -2.09858,0.93956 -2.09858,2.09858l0,10.85345c0,1.15912 0.93956,2.09858 2.09858,2.09858l2.28706,0l0,3.49722c0,0.95682 1.17573,1.41445 1.82251,0.70946l3.54709,-3.86671c0.19874,-0.21657 0.4792,-0.33997 0.77321,-0.33997l7.36572,0c1.15897,0 2.09858,-0.93946 2.09858,-2.09858l0,-3.98801",
		fill: "none",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		strokeLinecap: "round"
	}));
});
export default SvgChatSparkle;
